module.exports = __webpack_public_path__ + "img/logo-2.61836d85.png";